import { useCallback, useEffect, useRef, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Image,
  Navbar, 
  Row,
} from "react-bootstrap";
import login_img from "../../assets/images/login-img-new.svg";
import password_hide_icon from "../../assets/images/password-hide-icon.svg";
import password_show_icon from "../../assets/images/password-show-icon.svg";
import "./login.css";
import { Link } from "react-router-dom";
import { useLocalizedRoutes } from "../../hooks/useLocalizedRoutes";
import Feedback from "react-bootstrap/esm/Feedback";
import warning_icon from "../../assets/images/warning-icon-yellow.svg";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { logout, startLogin } from "../../store/auth";
import { MiniLoader } from "../ui/MiniLoader";
import { HelpInfo } from "../ui/HelpInfo";
import axiosApi from "../../axios/axios-api";
import PetroprixLogo from "../../assets/images/petroprix-logo";
import { getRecaptchaLanguage } from "../../helpers/recaptchaLanguage";
import { LocalizedRecaptcha } from "../ui/LocalizedRecaptcha";

export const LoginScreen = () => {
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [numLogins, setNumLogins] = useState(0);
  const { t, i18n } = useTranslation();
  const { getPath } = useLocalizedRoutes();
  const dispatch = useDispatch();
  const { status, error } = useSelector((state) => state.auth);
  const [showPassword, setShowPassword] = useState(false);
  const [iconShowPassword, setIconShowPassword] = useState(password_hide_icon);
  const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITEKEY;
  const [captchaValid, setCaptchaValid] = useState(null);
  const captchaRef = useRef(null);
  const [telefono, setTelefono] = useState(t("ayuda.telefono"));
  const [email, setEmail] = useState(t("ayuda.email"));
  const captchaLanguage = getRecaptchaLanguage(
    i18n.resolvedLanguage || i18n.language
  );

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [formErrors, setFormErrors] = useState({
    email: false,
    password: false,
  });

  const onChange = () => {
    if (captchaRef.current.getValue()) {
      setCaptchaValid(true);
    } else {
      setCaptchaValid(false);
    }
  };

  const onLogin = async (event) => {
    setLoading(true);
    setValidated(false);
    setCaptchaValid(null);
    setFormErrors({ email: false, password: false });
    setNumLogins(numLogins + 1);
    event.preventDefault();

    if (
      formData.email === "" ||
      !formData.email.includes("@") ||
      !formData.email.includes(".") ||
      formData.password === ""
    ) {
      const validateForm = {
        email:
          formData.email !== "" &&
          formData.email.includes("@") &&
          formData.email.includes("."),
        password: formData.password !== "",
      };
      setFormErrors(validateForm);

      setValidated(true);
      dispatch(logout({ error: null }));
      setLoading(false);
      return;
    }

    if (captchaValid) {
      dispatch(
        startLogin(
          formData.email,
          formData.password,
          captchaRef.current.getValue()
        )
      );
      setLoading(false);
    } else {
      dispatch(logout({ error: null }));
      setCaptchaValid(false);
      setLoading(false);
    }

    captchaRef.current.reset();
  };

  useEffect(() => {
    if (status === "checking") {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [status]);

  useEffect(() => {
    if (status === "checking") {
      dispatch(logout({ error: null }));
    }
  }, []);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
    showPassword
      ? setIconShowPassword(password_hide_icon)
      : setIconShowPassword(password_show_icon);
  };

  const fetchInfoContacto = useCallback(async () => {
    try {
      if (process.env.REACT_APP_URL_API) {
        const response = await axiosApi.get("infoPetroprix", {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response?.data?.code === 200) {
          let data = response.data.data;
          setTelefono(data.telefono);
          setEmail(data.email_informacion);
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchInfoContacto();
  }, []);

  return (
    <>
      <Container className=" d-lg-none d-xl-none ">
        <Navbar
          collapseOnSelect
          expand="lg"
          className="menu px-1"
          style={{ display: "flex" }}
        >
          <Navbar.Brand
            as={Link}
            to={getPath('login')}
            className="d-flex flex-column align-items-start"
          >
            <PetroprixLogo className="d-inline-block align-left login-page-logo" />
            <Col xs={12} lg={{ span: 12, order: 1 }}>
              <h3>
                {t("login.header.h1")}
                {t("login.header.h1.red")}
              </h3>
            </Col>
          </Navbar.Brand>
          <HelpInfo telefono_informacion={telefono} email={email} />
        </Navbar>
      </Container>
      <Container className="content-login-page">
        <Col xs={12} lg={{ span: 11, offset: 1 }}>
          <Container className="login-header-container">
            <header className="d-none d-lg-block">
              <PetroprixLogo className="d-inline-block align-left login-page-logo" />
              <Col xs={12} lg={{ span: 12, order: 1 }}>
                <h3>
                  {t("login.header.h1")}
                  {t("login.header.h1.red")}
                </h3>
              </Col>
            </header>
            <HelpInfo
              className={"d-none d-lg-block"}
              telefono_informacion={telefono}
              email={email}
            />
          </Container>
        </Col>
        <Container className="login-container">
          <Row className="content-section login-section">
            <Col xs={12} lg={{ span: 4, offset: 2, order: 3 }}>
              <h2 className="mt-2 text-center">{t("login.h2")}</h2>
              {error !== null &&
                error !== "Captcha no válido" &&
                !loading &&
                numLogins > 0 && (
                  <Alert variant="danger-login">
                    <b>{error}</b>
                  </Alert>
                )}
              {error !== null &&
                error === "expired" &&
                !loading &&
                numLogins === 0 && (
                  <Alert variant="warning-login">
                    <img
                      src={warning_icon}
                      className="warning-icon-label"
                      alt={t("login.warning.sesion.expired")}
                    />
                    <b>{t("login.warning.sesion.expired")}</b>
                  </Alert>
                )}
              {(captchaValid === false ||
                (error === "Captcha no válido" &&
                  !loading &&
                  numLogins > 0)) && (
                <Alert variant="danger-login">
                  <b>{t("login.form.captcha.not-valid")}</b>
                </Alert>
              )}
              <Form
                noValidate
                validated={validated}
                className="login-form"
                autoComplete="off"
                onSubmit={onLogin}
              >
                <Form.Group>
                  <Form.Label htmlFor="email-field">
                    {t("login.form.email")}
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder={t("login.form.email")}
                    required
                    id="email-field"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    isInvalid={validated && !formErrors.email}
                    isValid={validated && formErrors.email}
                    autoComplete="off"
                  />
                  <Feedback type="invalid">
                    {t("login.form.email.invalid")}
                  </Feedback>
                </Form.Group>

                <Form.Group>
                  <Form.Label htmlFor="password-field" className="mt-3">
                    {t("login.form.password")}
                  </Form.Label>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder={t("login.form.password")}
                    required
                    id="password-field"
                    autoComplete="off"
                    onChange={(e) =>
                      setFormData({ ...formData, password: e.target.value })
                    }
                    isInvalid={validated && !formErrors.password}
                    isValid={validated && formErrors.password}
                    value={formData.password}
                  />
                  <span
                    toggle="#password-field"
                    className="toggle-password"
                    onClick={handleShowPassword}
                  >
                    <img src={iconShowPassword} className="passwordIcon" />
                  </span>
                  <Feedback type="invalid">
                    {t("login.form.password.invalid")}
                  </Feedback>
                </Form.Group>

                <Form.Group className="mt-2 form-login-forget">
                  <Link to={getPath('recovery')}>
                    {t("login.form.password.forget")}
                  </Link>
                </Form.Group>

                <div className="d-flex recaptcha mt-3">
                  <LocalizedRecaptcha
                    key={`recaptcha-${captchaLanguage}`}
                    ref={captchaRef}
                    sitekey={SITE_KEY}
                    hl={captchaLanguage}
                    onChange={onChange}
                    required
                  />
                </div>

                <div className="d-grid gap-2 mt-3">
                  <Button
                    variant="primary"
                    type="submit"
                    size="lg"
                    className="form-login-btn"
                    disabled={loading}
                  >
                    {loading ? <MiniLoader /> : t("login.form.btn-login")}
                  </Button>
                  <Form.Group className="mt-2 form-login-register">
                    <p>{t("login.form.p.sin-cuenta")}</p>
                    <Link to={getPath('register')} className="red-text">
                      {t("login.form.btn-registrar")}
                    </Link>
                  </Form.Group>
                  <p className="login-help-text">
                    {t("login.help.text")}{" "}
                    <a
                      href={`mailto:${email}`}
                      className="login-help-text-link"
                    >
                      {email}
                    </a>
                  </p>
                </div>
              </Form>
            </Col>
            <Col
              xs={12}
              lg={{ span: 4, offset: 1, order: 3 }}
              className="d-none d-lg-block"
            >
              <Image src={login_img} fluid="true" className="mt-5" />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};
